module.exports = __webpack_public_path__ + "static/media/tips-3.591d40e4.png";